import ApiClient from 'services/ApiClient';

import { getLocale, getTimezone } from 'helpers/localization';

export type Nutrients = {
    calories: number;
    kilocalories: number;
    fat: number;
    saturated_fat: number;
    carbs: number;
    sugar: number;
    fibre: number;
    protein: number;
    salt: number;
};

export type MealPlanResponse = {
    meal_type: string;
    meals: {
        id: number;
        name: string;
        form: string;
        service_name: string;
        serving_name: string;
        serving_count: number;
        serving_weight: number;
        cover: string;
        cooking_level: string;
        cooking_time: number;
        default_serving_size: number;
        nutrients: Nutrients;
        updated_at: string;
        is_favourite: boolean;
        recommended_serving_size: number;
        steps_count: number;
        ingredients_count: number;
    }[];
}[];

export type MealStep = {
    position: number;
    text: string;
};

export type MealIngredient = {
    id: number;
    name: string;
    allergens: string[];
    measure: string;
    measure_name: string;
    quantity: number;
    is_optional: boolean;
    position: number;
    alternatives: MealIngredient[];
};

export type MealResponse = {
    id: number;
    name: string;
    form: string;
    service_name: string;
    serving_name: string;
    serving_count: number;
    serving_weight: number;
    cover: string;
    cooking_level: string;
    cooking_time: number;
    default_serving_size: number;
    steps_count: number;
    ingredients_count: number;
    nutrients: Nutrients;
    updated_at: string;
    is_favourite: boolean;
    rate: number;
    steps: MealStep[];
    ingredients: MealIngredient[];
};

const getNutritionHeaders = (): Record<string, string> => ({
    locale: getLocale(),
    'timezone-string': getTimezone(),
});

class NutritionApi {
    getMealPlan = async <Response = MealPlanResponse>(date: string): Promise<Response> =>
        await ApiClient.private.get<Response>(
            `workout-service/meal-planner/plans/${date}`,
            undefined,
            getNutritionHeaders()
        );

    getMealById = async <Response = MealResponse>(id: number): Promise<Response> =>
        await ApiClient.private.get<Response>(
            `workout-service/meal-planner/recipes/${id}`,
            undefined,
            getNutritionHeaders()
        );
}

export default NutritionApi;
